module.exports = __webpack_public_path__ + "6895c3dc5be364ce88148d08e9fb93f3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ni.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ni.svg
// module chunks = 0